import { render } from "./number-range.vue?vue&type=template&id=2c98547a&scoped=true&ts=true"
import script from "./number-range.vue?vue&type=script&lang=ts"
export * from "./number-range.vue?vue&type=script&lang=ts"

import "./number-range.vue?vue&type=style&index=0&id=2c98547a&lang=scss&scoped=true"
/* custom blocks */
import block0 from "../i18n/messages.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3593438386%2Fsrc%2Fpadme-ui-aws%2Fapps%2Fmain%2Fsrc%2Fcomponents%2Finfogroup-filters%2Fcomponents%2Fnumber-range.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c98547a"]])

export default __exports__